module.exports = __webpack_public_path__ + "380b62067fd2ee08727e7f8550410cfa.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/painters/eomsad.png
// module id = 2715
// module chunks = 0